import { put, takeEvery } from 'redux-saga/effects';

import { PurchaseAction } from '../actions';
import { PurchaseConstant } from '../constants';

export default function* () {
  yield takeEvery(
    [
      PurchaseConstant.CREATE_PURCHASE_SUCCESS,
      PurchaseConstant.EDIT_PURCHASE_SUCCESS,
    ],
    createOrEditPurchaseSuccess,
  );
  yield takeEvery(
    [
      PurchaseConstant.DELETE_PURCHASE_SUCCESS,
      PurchaseConstant.RESTORE_PURCHASE_SUCCESS,
    ],
    deleteOrRestorePurchaseSuccess,
  );
  yield takeEvery(PurchaseConstant.GET_PURCHASES_SUCCESS, getPurchasesSuccess);
  yield takeEvery(PurchaseConstant.GET_PURCHASE_SUCCESS, getPurchaseSuccess);
}

function* createOrEditPurchaseSuccess() {
  yield put(PurchaseAction.setPurchase({}));
}

function* deleteOrRestorePurchaseSuccess() {
  yield put(PurchaseAction.getPurchases());
}

function* getPurchasesSuccess(action) {
  yield put(PurchaseAction.setPurchases(action?.payload));
}

function* getPurchaseSuccess(action) {
  yield put(PurchaseAction.setPurchase(action?.payload));
}
